'use strict';

var React = require('react');

var SvgStoreStatusMajor = function SvgStoreStatusMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 10a3.987 3.987 0 0 0-1.172-2.828l1.415-1.415a6 6 0 1 1-5.243-1.674v-2.021a8.001 8.001 0 0 0 1 15.938 8 8 0 0 0 5.657-13.657l1.413-1.413a9.969 9.969 0 0 1 2.93 7.07c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10c.338 0 .671.017 1 .05v8.218a2 2 0 1 1-2 0v-2.142a4.002 4.002 0 0 0 1 7.874 4 4 0 0 0 4-4z"
  }));
};

exports.SvgStoreStatusMajor = SvgStoreStatusMajor;
